// @flow

import { Map } from 'immutable';
import connect from '@active/awe-ui-core/lib/hoc/connect';
import { getLocale } from 'modules/app/selector';
import EventList from 'components/EventList/EventList';
import {
  getUmbrellaEvents, isLoadingUmbrellaEvents, getLatestKeywords, getTotalUmbrellaEvents, getEventPageNumber,
} from '../duck/selector';
import { changePage } from '../duck/duck';

import './UmbrellaEvents.scss';

const mapState = (state: Map<*, *>) => ({
  events: getUmbrellaEvents(state),
  locale: getLocale(state),
  spin: isLoadingUmbrellaEvents(state),
  total: getTotalUmbrellaEvents(state),
  pagination: true,
  keywords: getLatestKeywords(state),
  currentPage: getEventPageNumber(state),
});

const mapDispatch = (dispatch, ownProps) => {
  return {
    onClickPage(latestKeywords, page) {
      dispatch(changePage(latestKeywords, page, ownProps.portalType, ownProps.portalId));
    },
  };
};

export default connect(mapState, mapDispatch)(EventList);
